import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=1dd7ba1c&scoped=true"
import script from "./SideBar.vue?vue&type=script&scoped=true&lang=js"
export * from "./SideBar.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=1dd7ba1c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd7ba1c",
  null
  
)

export default component.exports